import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { NgWizardService } from 'ng-wizard';
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
} from "@angular/forms";
import { ToastClientService } from "src/app/services/toast/toast-client.service";
import { ApiService } from "../../../services/http/api.service";
import { ApiConfiguration } from "../../../services/http/api-configuration";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { createDecipher } from 'crypto';

@Component({
  selector: 'app-type2-create',
  templateUrl: './type2-create.component.html',
  styleUrls: ['./type2-create.component.scss']
})
export class Type2CreateComponent implements OnInit {
  @Output() type2createCartonData: EventEmitter<boolean> = new EventEmitter;
  @Output() campaignID: EventEmitter<number> = new EventEmitter;
  @Output() caplimit: EventEmitter<number> = new EventEmitter;
  @Output() cartonType: EventEmitter<number> = new EventEmitter;
  @Output() editRewardBifur: EventEmitter<boolean> = new EventEmitter;
  @Output() editType2Whitelist: EventEmitter<boolean> = new EventEmitter;
  @Output() editCommMatrix: EventEmitter<boolean> = new EventEmitter;

  @Input() id = "";
  @Input() cartonid = "";
  presentDate:any;
  formGroup;
  bannerImg:any=''
  homeImg:any =''
  cartoontype1:boolean;
  editCarton = {
    carton_feature_id: '2',
    carton_campaign_title: "",
    created_date: "",
    end_date: "",
    month_year:'',
    id: "",
    is_caplimit_overall: 0,
    module_enable_notification: "",
    module_expiry_notification: "",
    no_of_days: "",
    scan_limit: "",
    start_date: "",
    status: "",
    total_whitelist_users: "",
    updated_date: "",
    banner_image:this.bannerImg,
    pop_up_image:this.homeImg,
  }
  rewardbifurcationFlag: boolean = false;
  commMatrixFlag: boolean = false;
  specialOccationFlag: boolean = false;
  targetFlag: boolean = false;
  pointConfigFlag: boolean = false;
  whitelistFlag: boolean = false;
  cartonLocalDetail : any = {}

  constructor(
    private ngWizardService: NgWizardService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private toast: ToastClientService,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
  ) {
  }

  ngOnInit() {
    this.presentDate = new Date().toISOString().slice(0, 10);
    console.log("date",this.presentDate)
    this.cartonLocalDetail = JSON.parse(localStorage.getItem('cartonFlgs'))
    this.cartonType.emit(Number(this.editCarton.carton_feature_id))
    this.formGroup = this.fb.group({
      carton_campaign_title: new FormControl("", [Validators.required, Validators.pattern("[a-zA-Z0-9 ]*")]),
      carton_type: new FormControl("", [Validators.required]),
      month_year: new FormControl("", [Validators.required]),
      start_date: new FormControl("", [Validators.required]),
      end_date: new FormControl("", [Validators.required]),
      // scan_limit: new FormControl("", [Validators.pattern("[0-9]*")]),
      qr_allowed: new FormControl("", [Validators.required]),
      banner_image: new FormControl(""),
      home_image : new FormControl("")
    });
    console.log("id", this.id, "cartonid", this.cartonid)
    // debugger
    if (this.id == '1') {
      this.getCampaignDetail();
    }
  }
  getCampaignDetail() {
    this.apiService.get(this.apiConfig.CartonCampaignDetail + `?carton_campaign_id=${this.cartonid}`).subscribe((res: any) => {
      console.log(res)
      try{
        this.editCarton.month_year =res.data.data.carton_year +"-"+res.data.data.carton_month;
        this.formGroup.controls.month_year.value = res.data.data.carton_year +"-"+res.data.data.carton_month;
        this.editCarton = res.data.data;
        if(res.data.data.carton_month > 9) {
          this.editCarton.month_year = res.data.data.carton_year +"-"+res.data.data.carton_month;
        }else{
          this.editCarton.month_year = res.data.data.carton_year+"-0"+res.data.data.carton_month;
        }
        this.rewardbifurcationFlag = res.data.data.reward_bifurcation;
        this.whitelistFlag = res.data.data.whitelist;
        this.commMatrixFlag = res.data.data.comm_matrix;
        this.targetFlag = res.data.data.target_setup;
        this.pointConfigFlag = res.data.data.point_config;
        this.specialOccationFlag = res.data.data.special_occation;
        this.editRewardBifur.emit(res.data.data.reward_bifurcation)
        this.editType2Whitelist.emit(res.data.data.whitelist)
        this.editCommMatrix.emit(res.data.data.comm_matrix)
        console.log(this.editCarton)
      }catch{}
      console.log(this.editCarton)
    })
  }
  submit() {
    if (this.formGroup.invalid) {
      console.log(this.formGroup)
      this.toast.Error("All fields required")
      return
    }
    else {
      if (this.id == '0') {
        let formdata = new FormData();
        formdata.append("carton_campaign_title",this.formGroup.controls.carton_campaign_title.value);
        formdata.append("carton_feature_id", this.formGroup.controls.carton_type.value);
        formdata.append("month_year", this.formGroup.controls.month_year.value);
        formdata.append("start_date", this.formGroup.controls.start_date.value);
        formdata.append("end_date", this.formGroup.controls.end_date.value);
        formdata.append("scan_limit", this.formGroup.controls.qr_allowed.value);
        formdata.append( "is_caplimit_overall", "0");
        formdata.append( "banner_image",this.bannerImg);
        formdata.append( "popup_image",this.homeImg);
        this.apiService.upload1(this.apiConfig.createCartonCampaign, formdata).subscribe((res: any) => {
           console.log(res)
          try{
            console.log(res.body.data.id)
            if(res.body.data != 0){
            }
            this.type2createCartonData.emit(true)
            this.campaignID.emit(res.body.data.id);
            console.log(res)
            localStorage.setItem("type2_campaign_id", res.body.data.id)
            console.log(localStorage.getItem('type2_campaign_id'));
            this.toast.Success(res.body.data.message)
            }
          catch{
          }
        },err=>{
          console.log('err',err)
          this.toast.Error(err)
        })
      } else {
        let formdata = new FormData();
        formdata.append("carton_campaign_title",this.editCarton.carton_campaign_title);
        formdata.append("carton_feature_id", this.editCarton.carton_feature_id);
        formdata.append("month_year", this.editCarton.month_year);
        formdata.append("start_date", this.editCarton.start_date);
        formdata.append("end_date", this.editCarton.end_date);
        formdata.append("scan_limit", this.editCarton.scan_limit);
        formdata.append( "is_caplimit_overall", "0");
        formdata.append( "banner_image",this.bannerImg);
        formdata.append( "popup_image",this.homeImg);
        let payload = {
          carton_campaign_title: this.editCarton.carton_campaign_title,
          start_date: this.editCarton.start_date,
          end_date: this.editCarton.end_date,
          carton_feature_id:this.editCarton.carton_feature_id,
          month_year:this.editCarton.month_year,
          // module_enable_notification:this.formGroup.controls.module_enable_notification.value,
          // module_expiry_notification:this.formGroup.controls.module_expiry_notification.value,
          scan_limit: this.editCarton.scan_limit,
          is_caplimit_overall: '0',
          banner_image:this.bannerImage,
          popup_image:this.homeImg

        }
        console.log(payload)
        this.apiService.uploadFile(this.apiConfig.editCartonCapmpaign + `?id=${this.cartonid}`, formdata).subscribe((res: any) => {
          console.log(res)
          try{
            this.type2createCartonData.emit(true)
            this.toast.Success(res.body.data.message)
            this.cartonLocalDetail = { ...this.cartonLocalDetail , rewardBifurcation : true}
            this.type2createCartonData.emit(true)
            localStorage.setItem('cartonFlgs' , JSON.stringify(this.cartonLocalDetail))
            this.caplimit.emit(parseInt(this.formGroup.controls.is_caplimit_overall.value))
          }
          catch{}
        },err=>{
          console.log('err',err)
          this.toast.Error(err)
        })
      }
    }
  }

  selectType(e){
    console.log("event",e)
    this.editCarton.carton_feature_id =e
    this.cartonType.emit(Number(this.editCarton.carton_feature_id))
    console.log(e)
  }
  submit1(){
    this.type2createCartonData.emit(true)
  }
  bname ="|||||||||||||||||||||||||||||||||||||||||||||||||||";
  hname ="|||||||||||||||||||||||||||||||||||||||||||||||||||";

  bannerImage(e){
    console.log(e)
    this.bname = e.target.files[0].name;
    this.bannerImg = e.target.files[0]
    let reader = new FileReader();
    reader.onload = (event: any) => {
      this.editCarton.banner_image = event.target.result;
    }
    reader.readAsDataURL(e.target.files[0]);
  }

  homePageImage(e){
    this.formGroup.controls.home_image.setValue(e.target.files[0])
    this.homeImg = e.target.files[0]
    this.hname = e.target.files[0].name;
    let reader = new FileReader();
    reader.onload = (event: any) => {
      this.editCarton.pop_up_image = event.target.result;
    }
    reader.readAsDataURL(this.homeImg);

  }
}
